import { render, staticRenderFns } from "./ActTypeView.vue?vue&type=template&id=0e421e24&scoped=true"
import script from "./ActTypeView.vue?vue&type=script&lang=js"
export * from "./ActTypeView.vue?vue&type=script&lang=js"
import style0 from "./ActTypeView.vue?vue&type=style&index=0&id=0e421e24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e421e24",
  null
  
)

export default component.exports